// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35oG2","controls":"styles_controls__34ezM","charLimit":"styles_charLimit__3c8ZQ","input":"styles_input__ZH12h","send":"styles_send__10f3q"};